import Vue from 'vue';
import JsEncrypt from 'jsencrypt/bin/jsencrypt';

import {
    IdCardAge,
    validateIdCard,
    removeItem,
    setBodyBackground,
    getItem, setItem,
    publicKey,
    regPhone,
    regSymbol,
    formatMoney,
    toBranch,
    push,
    replace,
    go,
    back,
    loading,
    success,
    successSync,
    error,
    toast,
    clear,
    confirm,
    alert,
    twoJsonMerge,
    regCarNo
} from 'utils/defaultData';
import { throttle } from 'lodash';
import { vehicleCode } from 'utils/vehicleCode';
//获取车辆类型代码
Vue.prototype.$vehicleCode=vehicleCode;
//车牌验证
Vue.prototype.$regCarNo=regCarNo;
//将两个json对象合并
Vue.prototype.$JsonMerge=twoJsonMerge;
//清除全局缓存
Vue.prototype.$removeItem = removeItem;
//设置全局背景色
Vue.prototype.$setBodyBackground = setBodyBackground;
//设置获取全局缓存
Vue.prototype.$getItem = getItem;
Vue.prototype.$setItem = setItem;
//删除数组元素
Vue.prototype.$jsonDelete=Vue.delete;
// 微信支付
// 格式化金额
Vue.prototype.$formatMoney = formatMoney;
Vue.prototype.$toBranch = toBranch;
//rsa
Vue.prototype.$publicKey = publicKey;
Vue.prototype.$rsaEncrypt = val => {
    let jse = new JsEncrypt();
    jse.setPublicKey(publicKey);
    let rsaVal = jse.encrypt(val.toString());
    return rsaVal;
};
// 加载中的提示
Vue.prototype.$loading = loading;
// 成功提示
Vue.prototype.$success = success;
// 成功提示同步
Vue.prototype.$successSync = successSync;
// 失败提示
Vue.prototype.$error = error;
// 长文字提示
Vue.prototype.$toast = toast;
// 关闭Toast弹窗
Vue.prototype.$clear = clear;
// 输入框的确认
Vue.prototype.$confirm = confirm;
// 确认
Vue.prototype.$alert = alert;
// 页面跳转
Vue.prototype.$push = push;
Vue.prototype.$replace = replace;
Vue.prototype.$go = go;
Vue.prototype.$back = back;
// 验证手机号
Vue.prototype.$regPhone = regPhone;
//验证身份证号码
Vue.prototype.$validateIdCard = validateIdCard;
//计算年龄
Vue.prototype.$IdCardAge = IdCardAge;
//验证特殊符号
Vue.prototype.$regSymbol = regSymbol;
// 防抖
Vue.prototype.$debounce = (func, wait = 300) => throttle(func, wait,{ 'trailing': false });
